<kt-portlet class="mh-100">
  <kt-portlet-header
    [title]="
      !isFiltered
        ? 'Tasks grouped by ' + categoryName
        : 'Tasks grouped by ' + categoryName + ' ' + filtered
    "
  >
    <ng-container ktPortletTools>
      <kt-task-selection-bar
        [groupedByTeam]="groupedByTeam"
        [groupedByTemplate]="groupedByTemplate"
        [groupedByTag]="groupedByTag"
        [fromPatient]="groupedByPatient"
      >
      </kt-task-selection-bar>
      <button
        (click)="backToMainListView()"
        mat-raised-button
        matTooltip="Back"
        color="secondary"
        type="button"
      >
        <span class="svg-icon-md">Back</span>
      </button>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body class="flex-grow-1 scroll" [perfectScrollbar]="{ wheelPropagation: false }">
    <div *ngFor="let category of categories">
      <kt-accordion
        [category]="category"
        [userObjects]="userObjects"
        [categoryName]="categoryName"
        [groupedByTemplate]="groupedByTemplate"
        [groupedByTeam]="groupedByTeam"
        [groupedByTag]="groupedByTag"
        [groupedByPatient]="groupedByPatient"
        [tempFilteredEntities]="tempFilteredEntities"
        [filteredView]="filteredView"
      >
      </kt-accordion>
    </div>
  </kt-portlet-body>
</kt-portlet>
